import { EMPTY_CONVERSATION_ID } from "@/constant";
import { generateId } from "@/lib/utils";
import {
  Conversation,
  ConversationStatusEnum,
  MessageData,
  MessageStatusEnum,
  File,
} from "@/types";

export const generateUserMessage = (
  content: string,
  files: File[],
  conversationId: number = EMPTY_CONVERSATION_ID
): MessageData => {
  return {
    message_id: generateId(),
    message_status: MessageStatusEnum.COMPLETED,
    type: "user",
    role: "user",
    content: [
      {
        type: "text",
        content: {
          text: content.trim(),
        },
      },
    ],
    files: files,
    created_at: new Date().toISOString(),
    conversation_id: conversationId,
    conversation_status: ConversationStatusEnum.ACTIVE,
    is_like: null,
  };
};

export const generateAiMessage = (data: MessageData): MessageData => {
  return {
    message_id: data.message_id || generateId(),
    message_status: data.message_status || MessageStatusEnum.COMPLETED,
    type: data.type || "response",
    role: data.role || "assistant",
    content: data.content || [],
    created_at: data.created_at || new Date().toISOString(),
    conversation_id: data.conversation_id || EMPTY_CONVERSATION_ID,
    conversation_status:
      data.conversation_status || ConversationStatusEnum.ACTIVE,
    is_like: data.is_like,
  };
};

export const generateConversation = (data: MessageData): Conversation => {
  return {
    conversation_id: data.conversation_id || EMPTY_CONVERSATION_ID,
    conversation_status:
      data.conversation_status || ConversationStatusEnum.ACTIVE,
  };
};
